// extracted by mini-css-extract-plugin
export default {"parent":"template_parent__aNZ9m","templatesList":"template_templatesList__C8qbW"};